const reviewsItemSelector = ".footer-top__reviews__item";
const reviewsButtonSelector = ".footer-top__controls__button";
const reviewsButtonActiveClass = "footer-top__controls__button--active";

function initScroller(reviewsElement: HTMLElement) {
  const buttons = document.querySelectorAll(reviewsButtonSelector);
  const scrollDistance = getScrollDistance(reviewsElement);

  setActiveIndex(reviewsElement, buttons, scrollDistance);
  reviewsElement.addEventListener("scroll", () => {
    setActiveIndex(reviewsElement, buttons, scrollDistance);
  });

  buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
      reviewsElement.scrollLeft = scrollDistance * index;
    });
  });
}

function setActiveIndex(
  reviewsElement: HTMLElement,
  buttons: NodeListOf<Element>,
  scrollDistance: number,
) {
  const scrollIndex = Math.round(reviewsElement.scrollLeft / scrollDistance);

  document
    .querySelector(`.${reviewsButtonActiveClass}`)
    ?.classList.remove(reviewsButtonActiveClass);

  buttons[scrollIndex]?.classList.add(reviewsButtonActiveClass);
}

function getScrollDistance(reviewsElement: HTMLElement) {
  const reviewElement = reviewsElement.querySelector<HTMLElement>(
    `${reviewsItemSelector}:nth-child(2)`,
  );
  if (!reviewElement) {
    return 0;
  }
  const reviewComputedStyle = getComputedStyle(reviewElement);
  return (
    Number.parseInt(reviewComputedStyle.getPropertyValue("width")) +
    Number.parseInt(reviewComputedStyle.getPropertyValue("margin-left"))
  );
}

export { initScroller };
